<template>
  <div class="home">
      <div class="top"></div>
      <van-nav-bar :fixed="true">
        <template #left>
          <div
            class="home-title one-text"
            @click="goLogin"
          >{{timeText}}<span v-if="isLogin">，{{userInfo.nickName}}</span></div>
        </template>
        <template #right>
          <div class="icon-box">
            <van-icon
              name="search"
              size="24"
              color="#0c34ba"
              @click="showPopup"
            />
          </div>
          <div class="icon-box">
            <van-icon
              name="scan"
              size="24"
              color="#0c34ba"
            />
          </div>
          <div class="icon-box">
            <van-icon
              name="calender-o"
              size="24"
              color="#0c34ba"
            />
          </div>
        </template>
      </van-nav-bar>
      <van-popup
        v-model="popupshow"
        position="top"
        :style="{ height: '100%' }"
      >
        <div class="popup-box">
          <div class="top"></div>
          <van-search
            v-model="value"
            placeholder="请输入搜索关键词"
            show-action
            @input="getSearchproducts"
          >
            <template #action>
              <div @click="onCancel">取消</div>
            </template>
          </van-search>
        </div>

        <div class="product-box search-pro clearfix">
          <div
            class="none"
            v-show='isnone'
          >抱歉，没有找到该商品！</div>
          <div
            class="product-item fl"
            :class="[index % 2 == 0 ? 'p-left' : 'p-right']"
            v-for="(item,index) in searchProducts"
            :key="index"
          >
            <div
              class="p-img"
              @click="viewProductInfo(item.pid)"
            >
              <img
                class="auto-img"
                :src="item.smallImg"
                alt=""
              >
            </div>
            <div class="pro-name one-text">{{item.name}}</div>
            <div class="clearfix">
              <div class="en-pro-name one-text fl">{{item.enname}}</div>
              <div class="pro-price fl">{{item.price}}</div>
            </div>
          </div>
        </div>

      </van-popup>

      <div class="scroll-box">
        <div class="main">
          <div class="banner-box">
            <van-swipe
              class="my-swipe"
              :autoplay="3000"
              indicator-color="#0C34BA"
              @change="onChange"
            >
              <van-swipe-item
                v-for="(item,index) in bannerData"
                :key="index"
                @click="viewProductInfo(item.pid)"
              >
                <img
                  class="auto-img"
                  :src="item.bannerImg"
                  :v-lazy="item.bannerImg"
                  alt=""
                >
                <div class="pro-info-banner one-text">{{item.name}}</div>
              </van-swipe-item>
              <template #indicator>
                <div class="custom-indicator">
                  {{ current + 1 }}/4
                </div>
              </template>
            </van-swipe>
          </div>
          <div class="hot-product">
            <div class="hot-product-title">热门推荐</div>
            <div class="product-box clearfix">
              <div
                class="product-item fl"
                :class="[index % 2 == 0 ? 'p-left' : 'p-right']"
                v-for="(item,index) in hotProducts"
                :key="index"
              >
                <div
                  class="p-img"
                  @click="viewProductInfo(item.pid)"
                >
                  <img
                    class="auto-img"
                    :src="item.smallImg"
                    alt=""
                  >
                </div>
                <div class="pro-name one-text">{{item.name}}</div>
                <div class="clearfix">
                  <div class="en-pro-name one-text fl">{{item.enname}}</div>
                  <div class="pro-price fl">{{item.price}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
import "../../assets/less/home.less";
export default {
  // 组件名称
  name: "Home",
  data() {
    return {
      // 搜索弹出层
      popupshow: false,

      // 搜索框的值
      value: "",

      // 搜索商品
      searchProducts: [],

      // 轮播图右下角显示器的值
      current: 0,

      // 早上/下午/晚上/深夜
      timeText: "",

      // 轮播图图片
      bannerData: [],

      // 热门商品
      hotProducts: [],

      // 是否登录
      isLogin: false,

      // 用户信息
      userInfo: {},

      // 没有该商品
      isnone: false,
    };
  },

  created() {
    this.getTime();
    this.getbannerData();
    this.getHotproducts();
    this.getUserInfo();
  },

  methods: {
    // 去登录
    goLogin() {
      let tokenString = localStorage.getItem("TK");
      if (!tokenString) {
        this.$router.push({ name: "Login" });
      }
    },

    // 弹出搜索层
    showPopup() {
      this.popupshow = true;
    },

    // 关闭搜索弹出层
    onCancel() {
      this.popupshow = false;
      this.value = "";
      this.searchProducts = [];
    },

    // 轮播图右下角显示器
    onChange(index) {
      this.current = index;
    },

    // 获取时间段
    getTime() {
      let hours = new Date().getHours();
      if (hours >= 6 && hours < 12) {
        this.timeText = "早上好";
      } else if (hours >= 12 && hours < 18) {
        this.timeText = "下午好";
      } else if (hours >= 18 && hours < 24) {
        this.timeText = "晚上好";
      } else {
        this.timeText = "深夜好";
      }
    },

    // 获取banner
    getbannerData() {
      this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
        duration: 0,
        loadingType: "spinner",
      });
      this.axios({
        methods: "GET",
        url: "/banner",
        // 如果是get请求，参数需要放在params，如果是post请求，参数需要放在data
        params: {
          appkey: this.appkey,
        },
      })
        .then((result) => {
          this.$toast.clear();

          if (result.data.code == 300) {
            this.bannerData = result.data.result;
          }
        })
        .catch((err) => {
          this.$toast.clear();
        });
    },

    // 获取热门商品数据
    getHotproducts() {
      this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
        duration: 0,
        loadingType: "spinner",
      });
      this.axios({
        methods: "GET",
        url: "/typeProducts",
        // 如果是get请求，参数需要放在params，如果是post请求，参数需要放在data
        params: {
          appkey: this.appkey,
          key: "isHot",
          value: 1,
        },
      })
        .then((result) => {
          this.$toast.clear();

          if (result.data.code == 500) {
            this.hotProducts = result.data.result;
          }
        })
        .catch((err) => {
          this.$toast.clear();
        });
    },

    // 查看商品详情
    viewProductInfo(pid) {
      this.$router.push({ name: "Detail", query: { pid } });
    },

    // 查询用户信息
    getUserInfo() {
      // 获取token字符串
      let tokenString = localStorage.getItem("TK");
      if (!tokenString) {
        return;
      }

      this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
        duration: 0,
        loadingType: "spinner",
      });
      this.axios({
        method: "GET",
        url: "/findMy",
        params: {
          appkey: this.appkey,
          tokenString,
        },
      })
        .then((result) => {
          this.$toast.clear();

          if (result.data.code == "A001") {
            if (result.data.result.length > 0) {
              this.isLogin = true;
              this.userInfo = result.data.result[0];
            }
          }
        })
        .catch((err) => {
          this.$toast.clear();
        });
    },

    // 搜索商品
    getSearchproducts() {
      this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
        duration: 0,
        loadingType: "spinner",
      });
      this.axios({
        methods: "GET",
        url: "/search",
        params: {
          appkey: this.appkey,
          name: this.value,
        },
      })
        .then((result) => {
          this.$toast.clear();
          if (result.data.code == "Q001") {
            if (this.value == "") {
              this.searchProducts = [];
              this.isnone = false;
              return;
            }
            if (result.data.result.length <= 0) {
              this.isnone = true;
            }
            this.searchProducts = result.data.result;
          }
        })
        .catch((err) => {
          this.$toast.clear();
        });
    },
  },
};
</script>